import { render, staticRenderFns } from "./AtenaItemsCard.vue?vue&type=template&id=fb5bf416&scoped=true"
import script from "./AtenaItemsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AtenaItemsCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AtenaItemsCard.vue?vue&type=style&index=0&id=fb5bf416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5bf416",
  null
  
)

export default component.exports